import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Impressum_DE, Impressum_FR } from 'components/Localization/Impressum'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

export const Impressum = ({
  lang = 'de',
  colorMode = 'light',
}: {
  lang?: 'de' | 'fr'
  colorMode?: 'light' | 'dark' | undefined
}) => {
  const Locales = lang === 'fr' ? Impressum_FR : Impressum_DE

  return (
    <TextWidth>
      <StyledImpressum colorMode={colorMode}>
        {Locales.entries.map((entry) => {
          const [funktion, name] = entry
          return (
            <Row>
              <Funktion>{funktion}</Funktion>
              <Name>{name}</Name>
            </Row>
          )
        })}
        <Row>
          <img src='https://interaktiv.tagesanzeiger.ch/static/icons/dasmagazin.svg' />
        </Row>
        <Row>
          <a className='source' href=''>
            © 2022 Das Magazin
          </a>
        </Row>
      </StyledImpressum>
    </TextWidth>
  )
}

const StyledImpressum = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  width: calc(100% - 60px);
  background-color: ${({ colorMode }) =>
    colorMode === 'dark'
      ? 'var(--brandblue-bright-1)'
      : 'var(--brandblue-bright-5)'};
  padding: 30px;
  display: flex;
  flex-direction: column;
  a {
    text-decoration: none;
    text-decoration: underline;
    &.source {
      color: var(--text-color);
    }
  }
`

const Row = styled.div`
  flex: 0 0 100%;
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  font-size: 15px;
  line-height: 1.3em;
  img {
    max-width: 50px;
    margin-left: auto;
    margin-right: auto;
  }
  a{
    color:var(--text-color)
  }
  a.source {
    width: 100%;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    color:var(--text-color)
  }
`

const Funktion = styled.div`
  flex: 0 0 40%;
  font-size: 15px;
  font-weight: 700;
  text-align: left;
`
const Name = styled.div`
  flex: 0 0 calc(60% - 30px);
`
